<footer class="footer pt-0">
  <div class="container pt-5 pb-4">
    <div class="row">
      <div class="col-xl-2 col-lg-3 col-md-4 col-6 offset-3 offset-sm-0">
        <img class="logo-footer" src="/assets/images/logoadip_footer.png" alt="Gobierno de la Ciudad de México" width="100%" />
      </div>
      <div class="col-xl-5 col-lg-4 offset-lg-1 offset-xl-1 col-md-5 col-12 mt-5 mt-md-0">
         <h3 class="text-center text-sm-left">Diseñado por la Agencia Digital de Innovación Pública</h3>
      </div>
      <div class="col-xl-3 col-lg-4 offset-xl-1 col-md-3 col-12 mt-5 mt-md-0">
         <h4 class="footer-title-links text-left text-light" style="font-weight: 700; font-size: 15px">Atención ciudadana</h4>
         <ul class="list-unstyled footer-list text-left text-light">
            <li><a class="footer-links" href="mailto:infoadip@cdmx.gob.mx" target="_blank" rel="noopener">datosabiertos@cdmx.gob.mx</a></li>
            <li><a class="footer-links" href="tel:5530900500" target="_blank" rel="noopener">55 3090 0500</a></li>
            <li><a class="footer-links" href="tel:5554475100" target="_blank" rel="noopener">55 5447 5100</a></li>
        </ul>
      </div>
    </div>
  </div>
  <hr class="hr-footer">
  <div class="footer-greca container-fluid text-light text-left pl-3 pt-3 pb-1">
  </div>
</footer>
